import React, {Component} from 'react'
import Slider from './Slider'
import {connect} from 'react-redux'
import {fetchAndUpdatePreferredSlider, fetchDefaultSliderIfNeeded} from '../../actions/defaultSlider'
import Modal from './Modal'
import {selectDefaultSlide, selectSlide} from '../../actions/sliders'
import { Radio, RadioGroup } from '@mui/material';
import classNames from 'classnames';

const mapStateToProps = ({
  courses: { selectedCourseCode, data },
  course: { selectedCourse },
  sliders,
}) => {
  return {
    courseId: selectedCourseCode,
    parentSSPNo: selectedCourse.parentSSPNo,
    sliders: sliders[selectedCourseCode].data,
    slider: sliders[selectedCourseCode].data.find(slider => {
      return slider.id === sliders[selectedCourseCode].defaultSlider
    }),
    defaultSlider: sliders[selectedCourseCode].defaultSlider,
    selectedSlide: sliders[selectedCourseCode].selectedSlide,
    isLoadingSlider: sliders[selectedCourseCode].receivedAt === null || sliders[selectedCourseCode].isFetchingDefaultSlider,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchDefaultSlider: (courseId, parentSSPNo) => {
      dispatch(fetchDefaultSliderIfNeeded(courseId, parentSSPNo))
    },
    switchSlider: (courseId, sliderId) => {
      dispatch(fetchAndUpdatePreferredSlider(courseId, sliderId))
    },
    switchDefaultSlide: courseId => {
      dispatch(selectDefaultSlide(courseId))
    },
    selectSlide: (courseId, slideId) => {
      dispatch(selectSlide(courseId, slideId))
    }
  }
}

class WeekSlider extends Component {
  state = {
    sliderSelectorOpen: false,
    selectedSlider: null,
    isSwitchingSliders: false
  }

  componentDidMount () {
    this.initialiseWeekInfo()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.courseId !== this.props.courseId) {
      this.initialiseWeekInfo()
    }

    if(this.state.isSwitchingSliders){
      if(prevProps.slider.id !== this.props.slider.id) this.toggleSliders();
    }
  }

  componentWillUnmount() {
    this.props.switchDefaultSlide(this.props.courseId)
  }

  initialiseWeekInfo = () => {
    this.props.fetchDefaultSlider(this.props.courseId, this.props.parentSSPNo)
  }

  handleOpenSliderSelector = () => {
    this.setState({
      sliderSelectorOpen: true,
      selectedSlider: this.props.defaultSlider,
    })
  }

  handleCloseSliderSelector = () => {
    this.setState({
      sliderSelectorOpen: false,
    })
  }

  toggleSliders = () => {
    this.setState({
      isSwitchingSliders: !this.state.isSwitchingSliders
    })
  }

  handleSubmitPreferredSlider = event => {
    event.preventDefault()
    this.toggleSliders();

    this.props.switchSlider(this.props.courseId, this.state.selectedSlider)

    this.handleCloseSliderSelector()
  }

  handleSwitchPreferredSlider = (event, value) => {
    event.preventDefault()

    this.setState({
      selectedSlider: value,
    })
  }

  renderSlider = () => {
    return (
      <Slider
        onSelectSlide={this.props.selectSlide}
        courseId={this.props.courseId}
        selectedSlider={this.props.defaultSlider}
        selectedSlide={this.props.selectedSlide}
        groups={this.props.slider.teachingPeriods.map(({calendarType}) => calendarType)}
        enableGroups={this.props.slider.groupByTeachingPeriod}
        weeks={this.props.slider.sliderItems.map(week => {
          return {
            id: week.id,
            title: week.sliderText,
            group: week.teachingPeriod ? week.teachingPeriod.calendarType : null,
          }
        })}
      />
    )
  }

  renderSliderSelector = () => {
    if (this.props.sliders.length <= 1) {
      return null
    }

    return (
      <Modal
        className="timeline"
        handleCloseModal={this.handleCloseSliderSelector}
        isOpen={this.state.sliderSelectorOpen}
        title="Change timeline"
      >
        <form onSubmit={this.handleSubmitPreferredSlider}>
          <p>You can change the timeline at any time based on the units are you currently studying.</p>
          <div className="timeline-list">
            <p className="timeline-label">Show me:</p>
            <RadioGroup
              className="timeline-items"
              name="timeline"
              onChange={this.handleSwitchPreferredSlider}
              valueSelected={this.state.selectedSlider}
            >
              {this.props.sliders.map(slider => {
                return (
                  <Radio
                    key={slider.id}
                    className="timeline-item"
                    label={slider.title}
                    value={slider.id}
                  />
                )
              })}
            </RadioGroup>
          </div>
          <button className="btn btn-primary">Change timeline</button>
        </form>
      </Modal>
    )
  }

  renderSliderSelectorButton = () => {
    if (this.props.sliders.length <= 1) {
      return null
    }

    return (
      <div className="timeline-selector">
        <span className="timeline-name">{this.props.slider.title}</span>
        <button onClick={this.handleOpenSliderSelector}>change</button>
      </div>
    )
  }

  render() {
    if (this.props.isLoadingSlider || !this.props.slider) {
      return null
    }

    if(!this.state.isSwitchingSliders){
      return (
        <div className={classNames(
          'gradient-container',
          {'gradient-container--not-grouped': this.props.slider && !this.props.slider.groupByTeachingPeriod}
        )}>
          <div className="container">
            {this.renderSliderSelectorButton()}
  
            {this.renderSlider()}
  
            {this.renderSliderSelector()}
          </div>
        </div>
      )
    }
    return null
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WeekSlider)
